import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/PressForm.css";
import { fileAPI, pressAPI } from "../../api/index"; // adjust path to match your project

function PressForm() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [status, setStatus] = useState("active");
  const [caption, setCaption] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleImageChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      setFile(selected);
      setPreview(URL.createObjectURL(selected));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!title.trim()) {
      setError("Please enter a press title.");
      return;
    }
    if (!file) {
      setError("Please choose a photo to upload.");
      return;
    }

    setSubmitting(true);
    try {
      const uploadRes = await fileAPI.upload(file, "press");
      const photoUrl =
        uploadRes.data?.url ||
        uploadRes.data?.file_url ||
        uploadRes.data?.photo_url;

      if (!photoUrl) {
        throw new Error(
          "Upload succeeded but the response didn't contain a usable URL field."
        );
      }

      await pressAPI.create({
        title,
        caption: caption || null,
        status,
        photo_url: photoUrl,
      });

      navigate("/dashboard/PressTable");
    } catch (err) {
      console.error("Press item save failed:", err);
      setError(
        err.response?.data?.detail || err.message || "Something went wrong while saving the press photo."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Add Press Photo</h2>
        <button className="back-btn-press" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>

      <form className="press-form" onSubmit={handleSubmit}>
        {error && <div className="press-form-error">{error}</div>}

        <div className="form-row">
          <div className="form-group">
            <label>Press Title</label>
            <input
              type="text"
              placeholder="Enter Press Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Status</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Upload Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
            />
          </div>
        </div>

        {preview && (
          <div className="press-preview-box">
            <img src={preview} alt="Preview" className="press-preview-img" />
          </div>
        )}

        <div className="form-group">
          <label>Caption / Description</label>
          <textarea
            rows="4"
            placeholder="Optional Caption"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          ></textarea>
        </div>

        <button className="sub-btn-press" type="submit" disabled={submitting}>
          {submitting ? "Uploading..." : "Submit Press Photo"}
        </button>
      </form>
    </div>
  );
}

export default PressForm;